// Extracts smart filters from a natural-language search, e.g. "pizza under $15 open now".
export const parseQuery = (raw) => {
  let text = raw || "";
  const out = { text: (raw || "").trim(), maxPrice: null, minDiscount: null, openNow: false, nearMe: false, withinDays: null, windowLabel: null };
  if (!text.trim()) return out;
  const price = text.match(/(?:under|below|less than|cheaper than|max|<)\s*\$?\s*(\d+(?:\.\d+)?)/i);
  if (price) { out.maxPrice = parseFloat(price[1]); text = text.replace(price[0], " "); }
  if (/\bopen\s+now\b/i.test(text)) { out.openNow = true; text = text.replace(/\bopen\s+now\b/i, " "); }
  if (/\b(near\s*(me|by)|nearby|close\s*to\s*me|around\s*me)\b/i.test(text)) {
    out.nearMe = true;
    text = text.replace(/\b(near\s*(me|by)|nearby|close\s*to\s*me|around\s*me)\b/i, " ");
  }
  const halfPrice = text.match(/\b(half\s*price|bogo|buy\s*one\s*get\s*one)\b/i);
  if (halfPrice) { out.minDiscount = 50; text = text.replace(halfPrice[0], " "); }
  const pct = text.match(/(?:at\s*least\s*)?(\d{1,2})\s*%\s*(?:or\s*more\s*)?(?:off|discount)?/i);
  if (pct) { out.minDiscount = Math.max(out.minDiscount || 0, parseInt(pct[1], 10)); text = text.replace(pct[0], " "); }
  const wk = text.match(/\b(this weekend|this week|today|tonight)\b/i);
  if (wk) {
    const m = wk[1].toLowerCase();
    if (m === "today" || m === "tonight") out.withinDays = 1;
    else if (m === "this week") out.withinDays = 7;
    else { const d = new Date().getDay(); out.withinDays = d === 0 ? 1 : 8 - d; }
    out.windowLabel = m;
    text = text.replace(wk[0], " ");
  }
  out.text = text.replace(/\s+/g, " ").trim();
  return out;
};
